import { Component, OnInit } from '@angular/core';
import {AuthRESTService} from '../../services/rest/auth-rest.service';
import { UploaderOptions, UploadFile, UploadOutput } from 'ngx-uploader';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import Commons from '../../pages/commons';
import {Observable, interval} from "rxjs";

@Component({
	selector: 'app-upload-users',
	templateUrl: './upload-users.component.html',
	styleUrls: ['./upload-users.component.css']
})
export class UploadUsersComponent extends Commons implements OnInit {
	public uploadOptions: UploaderOptions;
	isUploading: boolean = false;
	estimatedUsersPerSecond: number = 9; // users per second
	estimatedUsersDone: number = 0;
	progress: string = '0%';

	constructor(private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
		super(toastr, translate);
		this.uploadOptions = { concurrency: 1, allowedContentTypes: ['application/json'] };
	}

	ngOnInit() {
	}

	onUploadOutput(output: UploadOutput): void {
		this.clearNotifications();
		if (output.file != null) {
			this.estimatedUsersDone = 0;
			this.isUploading = true;
			let file: File = output.file.nativeFile;
			let reader = new FileReader();
			let users;
			reader.readAsText(file);
			reader.onload = () => {
				try {
					users = JSON.parse(reader.result as string);
					if (!users || !Array.isArray(users) || !users.length) {
						throw new Error();
					}
				} catch (err) {
					this.errorHandler(new Error('Could not read the file'));
					this.isUploading = false;
					return;
				}
				let sub = interval(1000).subscribe((val) => {
					this.estimatedUsersDone += this.estimatedUsersPerSecond;
					this.progress = Math.min(100, Math.round((this.estimatedUsersDone / users.length) * 100)) + '%';
				});
				let formData: FormData = new FormData();
				formData.append('name', file.name);
				formData.append('file', file, file.name);

				this.rest.post('manager/upload', formData).subscribe((response) => {
					if (response.NOK && Array.isArray(response.NOK) && response.NOK.length) {
						this.errorHandler(new Error('Could not import ' + response.NOK.length + '/' + users.length + ' user(s)'));
					} else {
						this.addSuccess('upload_users.upload_successful');
					}
					sub.unsubscribe();
					this.progress = '100%';
					this.isUploading = false;
				}, (err) => {
					sub.unsubscribe();
					this.progress = '100%';
					this.errorHandler(err);
					this.isUploading = false;
				});
			}
		}
	}
}
